export default "__VITE_ASSET__CUABd3Vi__"